/**
 * Created by Arif Topcu in 2019.
 */
import React from "react";
import ErrorModal from './ErrorModal';

let setErrorLegacy;
const MAX_ERROR_COUNT = 10;
class ErrorBoundary extends React.Component {
  state = { error: null};
  errorRenderRepeatCount = 0; //avoid infinite loops

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    //todo: log error
  }

  resetErrorBoundary = () => {
    this.errorRenderRepeatCount = 0;
    this.setState({error: null});
  }

  setError = (error) => {
    this.setState({error});
  }
  render() {
    setErrorLegacy = this.setError;
    const {error} = this.state;
    if (error) {
      this.errorRenderRepeatCount++;
    }
    return (
      <>
        <ErrorModal error={error} resetErrorBoundary={this.resetErrorBoundary}/>
        {this.errorRenderRepeatCount < MAX_ERROR_COUNT && this.props.children}
      </>
    );
  }
}

/**
 * similar to https://github.com/bvaughn/react-error-boundary/blob/master/src/index.tsx#L154
 * 2 ways of using it:
 * useErrorHandler(potentialErrorObject)
 *
 * or
 *
 * const errorHandler = useErrorHandler();
 * fetch('api').catch(err => errorHandler(err))
 *
 */
const useErrorHandler = (givenError) => {
  const [error, setError] = React.useState(null);
  if (givenError) throw givenError
  if (error) throw error
  return setError
}

const throwError = (err) => {
  if (setErrorLegacy) {
    setErrorLegacy(err);
  } else {
    console.error(err);
  }
};


export {
  useErrorHandler,
  throwError,
  ErrorBoundary,
}

